<template>
    <div class="Use_electricity_monitor">
        <!-- <div class="tree_container"> -->
        <div style="padding: 0 20px">
            <!-- <el-radio-group
                v-model="selectType"
                v-for="item in points"
                :key="item.tree_unit_type_id"
                @change="toggleTab(item.tree_unit_type_id)"
                class="leader-style-radio"
                size="middle"
            >
                <el-radio-button :label="item.type_name"></el-radio-button>
            </el-radio-group> -->
            <el-form class="leader-style-form" label-width="50px">
                <el-form-item label="类型">
                    <el-select v-model="selectType" @change="toggleTab">
                        <el-option
                            v-for="item in points"
                            :key="item.tree_unit_type_id"
                            :label="item.type_name"
                            :value="item.tree_unit_type_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div style="width: 100%; height: calc(100% - 1rem - 40px)">
                <!-- <me-collapes @collapesCb="collapesCb" :treeTitle="title"> -->
                <me-tree
                    ref="myTree"
                    :treeData="treeData"
                    :treeLoading="treeLoading"
                    :defaultProps="defaultProps"
                    :nodeKey="'point_id'"
                    :defaultCheckKeys="defaultCheckKeys"
                    :treeToolBar="treeToolBar"
                    @handleTreeNodeClick="handleTreeNodeClick"
                    :defaultExpandedKeys="defaultCheckKeys"
                    :isSingle="true"
                    @handleStretchClick="handleStretchClick"
                ></me-tree>
                <!-- </me-collapes> -->
            </div>
        </div>

        <!-- </div> -->
        <!-- <Monitor :nowClick="nowClick" :contWidth="contWidth"></Monitor> -->
        <Monitor :nowClick="nowClick" :contWidth="treeOuterWidth"></Monitor>
    </div>
</template>

<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import Monitor from "./components/monitor";
import * as api from "../../../http/Use_electricity_monitor";
import { getTreeUnitTypeTypeList, getTreeUnitListTypes } from "@/http/api";
// 解构 引入各个方法
// import { getElecInfo } from '../../../http/Use_electricity_monitor'
export default {
    components: {
        "me-tree": Tree,
        Monitor,
        "me-collapes": Collapes
    },
    data() {
        return {
            selectType: "采集点",
            selectTypeId: "",
            points: [],
            treeData: [],
            treeOuterWidth: 280,
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            // title: "采集点选择",
            treeLoading: false,
            treeToolBar: false,
            nowClick: {},
            contWidth: ""
        };
    },
    methods: {
        // 获取部门 区域
        getTreeUnitTypeTypeList() {
            getTreeUnitTypeTypeList({ point_class_id: "001" }).then(res => {
                if (res && res.error_code == 0) {
                    this.points = [
                        {
                            tree_unit_type_id: "0", // 采集点
                            type_name: "采集点"
                        }
                    ];
                    if (res.bus_json.length > 0) {
                        this.points.push(...res.bus_json);
                    }
                }
            });
        },
        toggleTab(type) {
            this.selectTypeId = type;
            if (type == "0") {
                this.getUnitPointList();
            } else {
                this.getTreeUnitListTypes(type);
            }
            // this.selectPointId = point_id;
        },
        //获取采集点
        getUnitPointList() {
            api.getUnitPointList({ point_class_id: "001" }).then(res => {
                if (res && res.error_code === "0") {
                    this.treeData = res.bus_json;
                    // if (!this.nowClick) {
                    //     this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    //     this.$forceUpdate();
                    // } else {
                    //     this.$refs.myTree.handleNodeClick(this.nowClick);
                    // }
                    this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    // this.nowClick = res.bus_json[0];
                }
            });
        },
        // 获取部门区域
        getTreeUnitListTypes(tree_unit_type_id) {
            getTreeUnitListTypes({
                point_class_id: "001",
                tree_unit_type_id
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.treeData = res.bus_json;
                    this.transFormerData(this.treeData);
                    this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    // this.nowClick = res.bus_json[0];
                }
            });
        },
        transFormerData(datas) {
            datas.forEach(item => {
                item["point_id"] = item.tree_unit_id;
                item["point_name"] = item.tree_unit_name;
                if (item.childList && item.childList.length > 0) {
                    this.transFormerData(item.childList);
                }
            });
        },

        handleTreeNodeClick(sth) {
            // this.nowClick = sth;

            this.nowClick = { selectTypeId: this.selectTypeId, ...sth };
        },
        handleStretchClick(treeOuterWidth) {
            this.treeOuterWidth = treeOuterWidth;
        }
        // collapesCb(collapes) {
        //     this.contWidth = collapes ? false : true;
        //     this.loading = true;
        //     setTimeout(() => {
        //         this.loading = false;
        //     }, 500);
        // }
    },
    created() {
        this.selectTypeId = "0";
        this.getTreeUnitTypeTypeList();
        this.getUnitPointList();
    }
};
</script>

<style lang="scss">
.Use_electricity_monitor {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    .tree_container {
        // width: 280px;
        padding-bottom: 10px;
        height: calc(100% - 10px);
    }

    .el-card {
        // border: 1px solid #ebeef5;
        // background-color: #fff;
        color: #303133;
        -webkit-transition: 0.3s;
        transition: 0.3s;
    }
    .is-alway-shadow {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
}
@media screen and (max-width: 1366px) {
   .el-radio-button{margin-bottom: 10px;}
    .instant .tab_cont{display: inline-block; }
    .btn_cont{text-align: right;margin-right: 4rem;}
}

</style>
